import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { downloadDoc } from '../../../../../common/services/http/documentsService';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';
import { Tooltip } from '@progress/kendo-react-tooltip';

import './documentNameCell.scss';

const DocumentNameCell = (props) => {
  if (props.rowType === 'groupHeader') {
    return null;
  }

  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  const [isRead, setIsRead] = useState(props.dataItem.isRead);

  useEffect(() => {
    setIsRead(props.dataItem.isRead);
  }, [isRead]);

  const updateIsReadFlag = (isRead) => {
    setIsRead(isRead);
    props.dataItem.isRead = isRead;
  };

  const linkToOrigin = props.origin === 'homePage' ? 'documents/pdf' : 'pdf';
  const docId = props.dataItem[props.idField || 'id'];

  return (
    <td className="document-cell" style={{ width: props.width }}>
      <Tooltip anchorElement="target">
        <div className="document-name-wrapper">
          {props.icon}
          {props.dataItem.fileType.toLowerCase() === 'pdf' ? (
            <Link to={`${linkToOrigin}/${docId}`}>
              <span
                title={props.dataItem[props.field]}
                style={{ fontWeight: !isRead ? 'bold' : 'normal' }}
                onClick={() => {
                  updateIsReadFlag(true);
                }}>
                {props.dataItem[props.field]}
              </span>
            </Link>
          ) : (
            <span style={{ fontWeight: !isRead ? 'bold' : 'normal' }} onClick={() => downloadDoc(props.dataItem)}>
              {props.dataItem[props.field]}
            </span>
          )}
        </div>
      </Tooltip>
    </td>
  );
};

export default DocumentNameCell;
